import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { PATH_ROUTES } from "../router/routes";

const COMPARE_ELIGIBLE_PATHS: string[] = [
  PATH_ROUTES.titulacions,
  PATH_ROUTES.professionsRegulades,
];

interface CompareContextType {
  isComparing: boolean;
  toggleCompare: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const CompareContext = createContext<CompareContextType>({
  isComparing: false,
  toggleCompare: noop,
});

export const CompareProvider = ({ children }: { children: ReactNode }) => {
  const [isComparing, setIsComparing] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!COMPARE_ELIGIBLE_PATHS.includes(pathname)) {
      setIsComparing(false);
    }
  }, [pathname]);

  const toggleCompare = () => setIsComparing((prev) => !prev);

  return (
    <CompareContext.Provider value={{ isComparing, toggleCompare }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => useContext(CompareContext);
